import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import { useList } from '@ztechapps/common.hook'
import { vendorAddressesQuery } from '../graphql'
import type { SetOptional } from 'type-fest'
import merge from 'lodash/merge'

export type UseVendorAddressProps = SetOptional<UseListProps, 'query' | 'entity'> & { showAll?: boolean }
export const useVendorAddress = ({ sort, limit, options, ...rest }: UseVendorAddressProps): UseListResult => {
  sort = sort ?? { fullAddress: 1 }
  limit = limit ?? 0

  options = merge({}, options, {
    queryOptions: {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  })
  return useList({
    query: vendorAddressesQuery,
    entity: 'vendorAddresses',
    limit,
    sort,
    options,
    ...rest,
  })
}
